import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./login.css";
import { resetPassword } from './api'; 

const ResetPassword = ({ setActiveComponent }) => {
  const [emailOrPhone, setEmailOrPhone] = useState("");
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const validateEmailOrPhone = (value) => {
    if (!value.trim()) return "email or phone is Required";
    const isEmail = /\S+@\S+\.\S+/.test(value);
    const isPhone = /^\d{10}$/.test(value);
    if (!isEmail && !isPhone) return "Invalid email/phone address";
    return "";
  };

  const handleBlur = (field, value) => {
    let newErrors = { ...errors };
    if (field === "emailOrPhone") newErrors.emailOrPhone = validateEmailOrPhone(value);
    setErrors(newErrors);
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    const emailError = validateEmailOrPhone(emailOrPhone);

    if (emailError ) {
      setErrors({ emailOrPhone: emailError });
      return;
    }

    try {
      const response = await resetPassword(emailOrPhone);

      if (response.status === 200 && response.data.success === true) {
        alert(response.data.message);
        navigate("/login");
      } else {
        alert("Invalid credentials");
      }
    } catch (error) {
    //  console.error("Login error:", error);
      alert("Login failed. Please try again.");
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
      <img src="/favicon.ico" alt="Logo" className="logo-icon" />
        <h2 className="login-header">EnergyAtlas - EMS</h2>
        <form onSubmit={handleLogin}>
          <div className="input-container">
            <input
              type="text"
              className={`input-box ${errors.emailOrPhone ? "error" : ""}`}
              value={emailOrPhone}
              onChange={(e) => setEmailOrPhone(e.target.value)}
              onBlur={(e) => handleBlur("emailOrPhone", e.target.value)}
              placeholder=" "
            />
            <label className={errors.emailOrPhone ? "error-label" : ""}>Email / Phone no *</label>
            {errors.emailOrPhone && <div className="error-message">{errors.emailOrPhone}</div>}
          </div>
          <button type="submit" className="login-buttons">GET LINK TO RESET PASSWORD</button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
